import * as React from "react";
import FlightReportList from "../flightReport/FlightReportList";
import { useEffect } from "react";

interface IDashboardProps {}

const Dashboard: React.FunctionComponent<IDashboardProps> = (props) => {
    useEffect(() => {
        document.title = "Flight Report Dashboard | Aviation";
    }, []);
    return (
        <>
            <FlightReportList />
        </>
    );
};

export default Dashboard;
